import { apiAxiosCMS, graphql } from 'services/api';
import { GET_PAGES } from 'graphqlQueriesAndMutations/queries';
import { PageProps } from 'types/PageProps';
import { GeneralConfigProps } from 'types/GeneralConfigProps';

interface RespGetPagesProps {
	isSuccess: boolean;
	data: PageProps[];
}

export async function getPages(handleNotify: any) {
	const resp: RespGetPagesProps = { isSuccess: false, data: [] };

	await graphql
		.query({ query: GET_PAGES, variables: { limit: 100 } })
		.then((res) => {
			resp.data = res.data?.pagesPaginated?.data || [];
			resp.isSuccess = true;
		})
		.catch((error) => {
			resp.data = [];
			resp.isSuccess = false;
			handleNotify(error?.message || 'Erro ao buscar as páginas', 'error');
		});

	return resp;
}

interface SaveGeneralConfigsResp {
	isSuccess: boolean;
	data: GeneralConfigProps | null;
}

export async function saveGeneralConfigs(
	stringToSave: string | null,
	handleNotify: any
) {
	const resp: SaveGeneralConfigsResp = { isSuccess: false, data: null };

	await apiAxiosCMS
		.post('general-config/', {
			non_editable_pages: stringToSave
		})
		.then((res) => {
			resp.data = res.data;
			resp.isSuccess = true;
			handleNotify('Configuração salva', 'success');
		})
		.catch((error) => {
			resp.data = null;
			resp.isSuccess = false;
			handleNotify(error?.message || 'Erro ao buscar as páginas', 'error');
		});

	return resp;
}
